export default __webpack_public_path__ + "static/become-a-star-illustration-light-a7a7d212aeccf2412bc87580c5e66938.svg";